import moment from 'moment'
import { helpers } from 'vuelidate/lib/validators'

export const nameAlphaNumeric = (value = '') => {
  try {
    let nameRegex = /[a-zA-Z\s-*']+/g
    let maxNumberRegex = /(\d{0,4}$)+/g
    return (
      value.replace(nameRegex, '').replace(maxNumberRegex, '').length === 0
    )
  } catch (error) {
    return false
  }
}

export const fourOrNineDigitsLong = (value = '') => {
  try {
    return (
      value === null ||
      value.trim().length === 4 ||
      value.trim().length === 9 ||
      value.trim().length === 0
    )
  } catch (error) {
    return false
  }
}

export const deepClone = function(obj) {
  return new Promise((resolve, reject) => {
    resolve(JSON.parse(JSON.stringify(obj)))
  })
}

export const syncDeepClone = function(obj) {
  return JSON.parse(JSON.stringify(obj))
}

export const isDev = function() {
  return process.env.NODE_ENV === 'development'
}

export const isProduction = function() {
  return process.env.NODE_ENV === 'production'
}

export const isFunction = function(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
  )
}

export const formatDate = (date, format = 'MM/DD/YYYY') => {
  return date
    ? moment(date, [
      'MM/DD/YY',
      'MM/DD/YYYY',
      'MM-DD-YYYY',
      'MM-DD-YY',
      'YYYY-MM-DD'
    ]).format(format)
    : ''
}

export const formatMMMtoM = (value) => {
  return value ? moment().month(value).format('M') : ''
}

export const formatPhone = (value = '') => {
  try {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    return !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
  } catch (error) {
    return value
  }
}

export const formatTaxId = (value = '') => {
  try {
    const x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,7})/)
    return !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
  } catch (error) {
    return value
  }
}

export const escapeGroupName = (value = '') => {
  try {
    return value.replace(/[\u2012\u2013\u2014\u2015]/g, '-') // replace with hyphen
      .replace(/[`()]/g, '\'') // replace to single Quote
      .replace(/ü/g, 'u') // Replace with non-umlaut character
      .replace(/[?";|\u2122\u00ae\u00a9]/g, '') // remove ?,",;,|,™,®,©;
  } catch (error) {
    return value
  }
}

export const now = () => {
  return formatDate(new Date(), 'YYYY-MM-DD')
}

export const diff = function(arr, arr2) {
  var ret = []
  for (var i in arr) {
    if (arr2.indexOf(arr[i]) > -1) {
      ret.push(arr[i])
    }
  }
  return ret
}

export const getValueFromRefImpl = (input) => {
  if (input && input.effect) return input.value
  else return input
}

export const after = (param) => {
  return (value, vm) => {
    const date = getValueFromRefImpl(vm[param])
    if (date && moment(date).isValid() && moment(value).isValid()) {
      return moment(value).isAfter(date)
    }

    return true
  }
}

export const diffInMonths = (value) => {
  try {
    return moment().diff(value, 'months')
  } catch (error) {
    return value
  }
}

export const onOrAfter = (param) => {
  return (value, vm) => {
    const date = getValueFromRefImpl(vm[param])
    if (date && moment(date).isValid() && moment(value).isValid()) {
      return moment(value).isSameOrAfter(date)
    }

    return true
  }
}

export const before = (param) => {
  return (value, vm) => {
    const date = getValueFromRefImpl(vm[param])
    if (date && moment(date).isValid() && moment(value).isValid()) {
      return moment(value).isBefore(date)
    }

    return true
  }
}

export const onOrBefore = (param) => {
  return (value, vm) => {
    const date = getValueFromRefImpl(vm[param])
    if (date && moment(date).isValid() && moment(value).isValid()) {
      return moment(value).isSameOrBefore(date)
    }

    return true
  }
}

export const requireTriggerToChangeField = (triggerField, fieldToWatch) => {
  return function(value, vm) {
    const coverageChanged = value !== this.initialCoverage[fieldToWatch]
    if (!coverageChanged) {
      return true
    }

    const trigger = this[triggerField]
    if (!trigger) {
      return false
    }

    return true
  }
}

export const updateValues = (oldValues, newValue) => {
  // sometimes what gets passed into the prop "value", will not be a valid internal value
  // to this component. Eg: sometimes the API was only returning half the fields for privacy address
  // instead of doing a direct this.internalValue = newValue, this ensures we only update valid key/fields
  Object.keys(oldValues).forEach((key) => {
    // sometimes there won't be a valid newValue, eg: privacy address comes back with incomplete date
    oldValues[key] = newValue[key] || ''
  })
}

export const falsyAwareStringCompare = (a, b) => {
  // we're getting null back from the API in a lot of situations and we to consider null and an empty string as falsy
  a = a || ''
  b = b || ''

  return a === b
}

export const locatedInUStoForeignIndicator = (locatedInUS, foreignIndicator) => {
  if (locatedInUS !== undefined) {
    switch (locatedInUS) {
      case 'yes':
        return 'N'
      case 'no':
        return 'Y'
    }
  } else if (foreignIndicator !== undefined) {
    switch (foreignIndicator) {
      case true:
      case 'true':
        return 'Y'
      case false:
      case 'false':
        return 'N'
    }
  }

  return null
}
export const foreignIndicatorToLocatedInUS = (foreignIndicator, locatedInUS, defaultVal = '') => {
  switch (foreignIndicator) {
    case 'N':
    case 'false':
      return 'yes'
    case 'Y':
    case 'true':
      return 'no'
  }

  switch (locatedInUS) {
    case 'Y':
    case 'yes':
      return 'yes'
    case 'N':
    case 'no':
      return 'no'
  }

  return defaultVal
}

export const fiveOrNineDigitsLong = (value = '') => {
  try {
    return value.length === 5 || value.length === 9 || value.length === 0
  } catch (error) {
    return false
  }
}
export const fiveDigitsLong = (value = '') => {
  try {
    return value.length === 5 || value.length === 0
  } catch (error) {
    return false
  }
}
export const tenDigitsLong = (value = '') => {
  if(!value) {
    return true;
  }
  try {
    let cleanedValue = value.replace(/[^\d]/g, '')
    return cleanedValue.length === 10 || cleanedValue.length === 0
  } catch (error) {
    return false
  }
}
export const twelveDigitsLong = (value = '') => {
  try {
    return value.length === 12 || value.length === 0
  } catch (error) {
    return false
  }
}
export const currentOrFutureDate = (dateEntered = '') => {
  try {
    var date1 = moment(dateEntered).format('MM/DD/YYYY')
    var date2 = moment(new Date()).format('MM/DD/YYYY')
    return dateEntered.length === 0 || moment(date1).isSame(date2) || moment(date1).isAfter(date2)
  } catch (error) {
    return false
  }
}
export const emailExist = (arrayList, value) => {
  try {
    let exist = false
    arrayList.forEach(item => {
      if ((item.text.length !== 0 && value.length !== 0) && item.text.toLowerCase() === value.toLowerCase()) {
        exist = true
      }
    })
    return exist
  } catch (error) {
    return false
  }
}

export const errToString = (err) => {
  return new Promise((resolve, reject) => {
    if (typeof err === 'string') {
      resolve(err)
    } else if (err.response) {
      err.response.json().then(responseBody => {
        resolve(responseBody.userMessage)
      })
    } else if (typeof err === 'object' && err.message) {
      resolve(err.message)
    } else {
      reject(err)
    }
  })
}

export const convertAddressType = (address) => {
  return address.addressType || address.type
}

export const relationshipCodeToGenderCode = (relationshipCode) => {
  switch (relationshipCode) {
    case 'D':
    case 'W':
      return 'F'
    case 'H':
    case 'S':
      return 'M'
  }

  return ''
}

export const mapCloneToAccess = (subGroupAccess) => {
  return subGroupAccess.map((sg) => {
    return {
      ...sg,
      access: {
        ...sg.access,
        primaryContact: false,
        createGroupUsersAllowed: false
      }
    }
  })
}


export const fileBoundIdValidation = helpers.regex('fileBoundIdValidation', /^[a-zA-Z0-9|]*$/)

export const sortReports = (reports) => {
  return reports.sort((a, b) => {
    const aDate = a.requestDate || a.createDate
    const bDate = b.requestDate || b.createDate
    if (moment(aDate).isSame(bDate)) {
      return a.fileName.localeCompare(b.fileName)
    }

    if (moment(aDate).isBefore(bDate)) {
      return 1
    }

    return -1
  })
}

export const setCookie = (id, value) => {
  document.cookie = id + '=' + value
}

export const getCookie = (name) => {
  if (!document.cookie) {
    return null
  }
  const cookies = document.cookie.split(';')
    .map(c => c.trim())
    .filter(c => c.startsWith(name + '='))

  if (cookies.length === 0) {
    return null
  }
  return decodeURIComponent(cookies[0].split('=')[1])
}

export const titleCase = (raw, splitChar = ' ') => {
  const words = raw.split(splitChar);
  let out = '';
  for(let i = 0; i < words.length; i++) {
    out += words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
    if(i < words.length - 1) {
      out += ' ';
    }
  }
  return out;
}

export const camelToTitle = (camelCase) => { 
  return camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
}

// myCamelCase -> MY_CAMEL_CASE
export const camelToSnakeCaps = (camelCase) => {
  return camelCase
    .replace(/([A-Z])/g, '_$1')
    .replace(/^./, (str) => str.toUpperCase())
    .toUpperCase();
}

// these are all funcs from the formattable mixin.  Part of my
//  effort to stamp out all mixins before they start breeding
export const toDollarFormat = dollarFloat => {
  let numberString = Number.parseFloat(dollarFloat).toFixed(2);
  let parts = numberString.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `$${parts.join('.')}`;
}

export const toLocalDate = (date) => {
  return date ? formatDate(date, 'MM/DD/YYYY') : '';
}

export const toIso8601Date = (date) => {
  try {
    return formatDate(date, 'YYYY-MM-DD');
  } catch (error) {
    return ''; // whut we doin here?
  }
}
// TODO - unused func with undefined var
export const stringToIso8601 = (date) => {
  return this.toIso8601Date(moment(str, date).toDate());
}

export const validDate = (date) => {
  return moment(date).isValid();
}

// leave only pagr, group, subGroup Cks.  remove ids and names.
export const fixPagrParams = (raw = {}) => {
  const prefixes = ['group', 'parentGroup', 'subGroup'];
  const suffixes = ['Id', 'Name'];

  const fixed = Object.assign({}, raw);

  for(let prefix of prefixes) {
    for(let suffix of suffixes) {
      delete fixed[`${prefix}${suffix}`];
    }
  }
  return fixed;
}

export const parseQueryParams = url => Object.fromEntries(new URLSearchParams(url.split('?')[1]))
